import {mapResourceMetadata} from './mapResourceMetadata';
import {mapUpdateResourceBasePayload} from './mapUpdateResourceBasePayload';
import {IEditFileMetadataFormBaseValues} from '../components/FilesEditResourceForm/config';
import {emptyResourceMetadataLookupNames, IResourceMetadataLookupNames} from 'admin/resources/utils';

export const mapUpdateResourceScormPayload = (
  fileId: string,
  formValues: IEditFileMetadataFormBaseValues,
  lookupNames: IResourceMetadataLookupNames = emptyResourceMetadataLookupNames()
) => {
  const metadata = {...mapResourceMetadata(formValues, lookupNames), lengthInMinutes: formValues.time};
  const baseData = {data: new FormData(), fileId, metadata};
  const data = mapUpdateResourceBasePayload(baseData, formValues);

  return data;
};
